<template>
  <div v-if="usuarioValido">
    <protocolo-modal
      :protocoloGerado="protocolo"
      :agendamentoId="agendamentoId"
      @imprimeProtocolo="imprime"
    />
    <explicacao-modal />
    <regra-dias-pendentes-modal />
    <regra-ferias-pendentes-modal />
    <side-modal
      :inicioAtividade="dataInicioAtividade"
      :inicioSabado="agendaSabado"
      :inicioDomingoFeriado="agendaDomingoFeriado"
      @agendaData="gravaData"
      @mostraProtocolo="abreProtocolo"
    />
    <section role="form">
      <div class="main-container container container-top">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-content">
                <h4>Chefe Imediato&nbsp;<small>(Aprovador)</small></h4>
                <section>
                  <table-loader :carregando="carregandoAprovador">
                    <div
                      class="alert alert-warning"
                      role="alert"
                      style="text-align: center"
                      v-if="escondeAprovador"
                    >
                      <i class="fa fa-flag-o fa-lg"></i>&nbsp; Sistema fechado para atualização. 
                      Agendamentos poderão ser solicitados a partir do dia 05.
                    </div>
                    <div
                      class="alert alert-warning"
                      role="alert"
                      style="text-align: center"
                      v-else-if="aprovadores && !aprovadores.length"
                    >
                      <i class="fa fa-flag-o fa-lg"></i>&nbsp; Você não tem
                      aprovador cadastrado. Relate esse problema ao seu chefe ou
                      superior.
                    </div>
                    <div
                      v-else
                      class="row"
                      v-for="aprovador in aprovadores"
                      :key="aprovador.id"
                    >
                      <div class="form-group col-lg-5 col-md-5 col-sm-5">
                        <label>Nome:</label>
                        <p>{{ aprovador.nome }}</p>
                      </div>
                      <div class="form-group col-lg-3 col-md-3 col-sm-3">
                        <label>Registro:</label>
                        <p>{{ aprovador.registro }}</p>
                      </div>
                      <div class="form-group col-lg-4 col-md-4 col-sm-4">
                        <label>Cargo:</label>
                        <p>{{ aprovador.cargo }}</p>
                      </div>
                    </div>
                  </table-loader>
                </section>
              </div>
            </div>
            <div class="card card-default">
              <div class="card-content">
                <card-header
                  :titulo="
                    `Agendamento de Férias ${feriasAgendadas.length &&
                      feriasAgendadas[0].periodo}`
                  "
                  subtitulo="(Como funciona o agendamento?)"
                  @abreModal="abreExplicacaoModal"
                />
                <section>
                  <table-loader :carregando="carregando">
                    <div
                      class="alert alert-warning"
                      role="alert"
                      style="text-align: center"
                      v-if="feriasAgendadas && !feriasAgendadas.length"
                    >
                      <i class="fa fa-flag-o fa-lg"></i>&nbsp; Você ainda não
                      tem período de férias para agendar.
                    </div>
                    <table class="table table-striped table-hover" v-else>
                      <thead>
                        <tr>
                          <th>Exercício</th>
                          <th>Data de Início</th>
                          <th class="hidden-xs hidden-xxs">Dias Pendentes</th>
                          <th class="hidden-xs hidden-xxs">Férias Pendentes</th>
                          <th class="hidden-xxs">Status</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="ferias in feriasAgendadas"
                          :key="ferias.id"
                          :class="
                            ferias.situacao === 'PENDENTE'
                              ? 'situacao-pendente'
                              : ''
                          "
                        >
                          <td>{{ ferias.periodo }}</td>
                          <td v-if="ferias.inicio">
                            {{ ferias.inicio | formataData }}
                          </td>
                          <td v-else>
                            <i
                              class="fa fa-ellipsis-h fa-lg"
                              aria-hidden="true"
                            ></i>
                          </td>
                          <td class="hidden-xs hidden-xxs">
                            <div style="text-align: center; width: 107px">
                              {{ ferias.diasPendentes ? 'SIM' : 'NÃO' }}
                            </div>
                          </td>
                          <td class="hidden-xs hidden-xxs">
                            <div style="text-align: center; width: 107px">
                              {{ ferias.feriasPendentes ? 'SIM' : 'NÃO' }}
                            </div>
                          </td>
                          <td class="hidden-xxs">
                            {{
                              ferias.situacao | descricaoStatus
                            }}
                          </td>
                          <td
                            class="td-btns td-btns-alone"
                            style="text-align: center"
                          >
                            <div>
                              <botao
                                :estilo="'vazado-laranja-sm'"
                                icone="editar-tabela"
                                @clicado="agenda('agendamento', ferias)"
                                v-show="mostraEditar(ferias)"
                                v-tooltip.left="'Editar'"
                              ></botao>
                              <botao
                                estilo="vazado-cinza-sm"
                                icone="visualizar"
                                @clicado="visualiza('agendamento', ferias)"
                                v-show="mostraVisualizar(ferias)"
                                v-tooltip.left="'Visualizar'"
                              ></botao>
                              <botao
                                estilo="vazado-vermelho-sm"
                                icone="fa-exclamation-triangle"
                                @clicado="
                                  agendaOuVisualiza('agendamento', ferias)
                                "
                                v-show="mostraDiasFeriasPendentes(ferias)"
                                v-tooltip.left="
                                  alternaTooltipDiasFerias(ferias)
                                "
                              ></botao>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="col-xs-12 footer-controller-inner">
                      <botao
                        estilo="cheio-verde-dir"
                        rotulo="Agendar"
                        icone="fa-calendar-check-o"
                        toggle
                        target
                        :disabled="!feriasAgendadas.length"
                        v-show="mostraEditar(primeiroPeriodoPendente)"
                        @clicado="
                          agenda('agendamento', primeiroPeriodoPendente)
                        "
                      ></botao>
                    </div>
                  </table-loader>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Botao from '@/components/botao';
import CardHeader from '@/components/card-header';
import TableLoader from '@/components/table-loader';
import ProtocoloModal from './protocolo-modal';
import ExplicacaoModal from './explicacao-modal';
import RegraDiasPendentesModal from './regra-dias-pendentes-modal';
import RegraFeriasPendentesModal from './regra-ferias-pendentes-modal';
import SideModal from './side-modal';
import moment from 'moment';
import Ferias from '@/domain/ferias';
import Aprovador from '@/domain/ferias/aprovador';
import ErrorHelper from '@/helpers/ErrorHelper';
import agendamentosMock from '../../../static/support/sample-data/agendamentos.json';
import api from '@/services/api';
import obtemImpressao from '@/services/obtemImpressao';

export default {
  name: 'Ferias',

  data() {
    return {
      funcionario: this.$store.state.funcionario,
      agendamentos: [],
      feriasAgendadas: [],
      dataInicioAtividade: '',
      uor: {},
      aprovadores: [],
      competencia: {},
      protocolo: '',
      agendamentoId: 0,
      agendaSabado: false,
      agendaDomingoFeriado: false,

      usuarioValido: true,
      carregandoAprovador: false,
      carregando: false,
      escondeAprovador: false,
    };
  },

  computed: {
    usuarioAtual() {
      return this.$store.state.funcionario;
    },
    primeiroPeriodoPendente() {
      const feriasReverse = [...this.feriasAgendadas].reverse();

      const pendente = feriasReverse.find(
        ferias => ferias.situacao === 'PENDENTE',
      );

      return pendente;
    },
    segundoPeriodoPendente() {
      if (!!this.primeiroPeriodoPendente) {
        const pendente = this.feriasAgendadas
          .filter(ferias => ferias.id !== this.primeiroPeriodoPendente.id)
          .find(ferias => ferias.situacao === 'PENDENTE');

        return pendente;
      }

      return undefined;
    },
  },

  watch: {
    usuarioAtual(novo, anterior) {
      this.editaRegistro(novo);
    },
  },

  methods: {
    // Métodos de input
    agenda(identidade, ferias) {
      try {
        this.validaPeriodoDeLancamento();
        this.validaUltimoAgendamento(ferias, this.feriasAgendadas);
        this.validaFeriasJahAgendadas(ferias);
        this.validaDiasEFeriasPendentes(ferias);

        const editavel = true;
        const inicio = this.trataInicioParaModal(ferias, this.feriasAgendadas);

        this.$emit('abreModal', { identidade, ferias, inicio, editavel });
      } catch (error) {
        if (error.type === 'error') {
          this.$root.$refs.toastr.e(error.message, 'Atenção');
          return;
        }
        if (error.type === 'warning') {
          this.$root.$refs.toastr.w(error.message, 'Atenção');
          return;
        }
        if (error.type === 'info') {
          this.$root.$refs.toastr.i(error.message, 'Obrigado');
          return;
        }
        if (!error.type) {
          this.$root.$refs.toastr.e(error.message, 'Atenção');
          return;
        }
        this.$root.$refs.toastr.e(error.message, 'Atenção');
      }
    },
    visualiza(identidade, ferias) {
      this.validaDiasEFeriasPendentes(ferias);

      const { inicio, protocolo } = ferias;
      const editavel = false;
      this.protocolo = protocolo;

      this.$emit('abreModal', { identidade, ferias, inicio, editavel });
    },
    agendaOuVisualiza(identidade, ferias) {
      if (ferias.situacao === 'PENDENTE') {
        this.agenda(identidade, ferias);
        return;
      }

      this.visualiza(identidade, ferias);
      return;
    },
    async imprime(id) {
      const endpoint = `agendamentos-ferias/${id}/protocolo`;

      try {
        await obtemImpressao(endpoint);
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        if (mensagem === 'Desbloqueie as pop-ups para este site') {
          this.$root.$refs.toastr.w(mensagem, 'Pop-up bloqueada');
        }
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },

    // Métodos de validações
    bloqueiaPorTipoFuncionario(tipo) {
      if (tipo !== 'QUADRO_PERMANENTE' && tipo !== 'CARGO_LIVRE_PROVIMENTO' && tipo !== 'CAPEP_CEDIDOS' && tipo !== 'CARGO_ELETIVO') {
        this.$router.push({ name: 'SemAcesso' });
        return true;
      }

      return false;
    },
    validaPeriodoDeLancamento() {
      const {
        dataInicioLancamento,
        dataFimLancamento,
      } = this.agendamentos[0].periodo;

      const [ano, mes, dia] = dataFimLancamento.split('-');
      const dataFimLancamentoAdicaoDia =  new Date(+ano, +mes - 1, +dia + 1);

      const periodoEstahFechado = !moment().isBetween(
        dataInicioLancamento,
        dataFimLancamentoAdicaoDia,
        'day', '[]'
      );

      if (periodoEstahFechado) {
        const erro = new Error('Período de agendamento fechado');
        erro.type = 'warning';
        throw erro;
      }
    },
    validaFeriasJahAgendadas(ferias) {
      if (!ferias) {
        const erro = new Error('Você já agendou as suas férias');
        erro.type = 'info';
        throw erro;
      }
    },
    validaUltimoAgendamento(ferias, feriasAgendadas) {
      const ehSegundoPeriodo =
        this.segundoPeriodoPendente &&
        ferias.id === this.segundoPeriodoPendente.id;

      if (ehSegundoPeriodo && !this.primeiroPeriodoPendente.inicio) {
        const erro = new Error(
          `Agende as férias de ${ferias.agendamentoAno - 1} antes`,
        );
        erro.type = 'error';
        throw erro;
      }
    },
    validaDiasEFeriasPendentes(ferias) {
      const temDiasPendentes = this.feriasAgendadas.find(
        ferias => ferias.diasPendentes,
      );
      const temFeriasPendentes = this.feriasAgendadas.find(
        ferias => ferias.feriasPendentes,
      );

      if (temDiasPendentes) {
        this.abreRegraDiasPendentes();
      }

      if (temFeriasPendentes) {
        this.abreRegraFeriasPendentes();
      }
    },

    // Métodos de leitura de dados
    async gravaData(payload) {
      const indexAgendamento = this.agendamentos.findIndex(
        item => item.id == payload.agendamentoId,
      );
      const indexFerias = this.feriasAgendadas.findIndex(
        item => item.id == payload.agendamentoId,
      );

      this.agendamentos[indexAgendamento].dataInicio = payload.inicio;
      this.agendamentos[indexAgendamento].statusAprovacao = 'EM_ANALISE';

      try {
        const id = this.agendamentos[indexAgendamento].id;
        const agendamento = this.agendamentos[indexAgendamento];
        const endPoint = `agendamentos-ferias/${id}`;

        const agendamentoResponse = await api.put(endPoint, agendamento);

        this.feriasAgendadas[indexFerias].inicio =
          agendamentoResponse.dataInicio;
        this.feriasAgendadas[indexFerias].situacao =
          agendamentoResponse.statusAprovacao;
        this.feriasAgendadas[indexFerias].protocolo =
          agendamentoResponse.protocolo.codigo;
        // this.feriasAgendadas[indexFerias].inicio = payload.inicio;
        // this.feriasAgendadas[indexFerias].situacao = 'EM_ANALISE';
        // this.feriasAgendadas[indexFerias].protocolo = 'AFDSA545252G744';

        const protocoloPayload = {
          protocolo: this.feriasAgendadas[indexFerias].protocolo,
          agendamentoId: id,
        };
        this.abreProtocolo(protocoloPayload);
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },
    async editaRegistro(funcionario) {
      if (funcionario) {
        if (this.bloqueiaPorTipoFuncionario(funcionario.tipo)) {
          this.usuarioValido = false;
          return;
        }

        this.listaAgendamentos(funcionario.id);
        await this.obtemMesCompetencia(funcionario.id);

        if (this.competencia.id) {
          this.listaAprovadores(this.competencia.id, funcionario.uorId);
        }
        this.dataInicioAtividade = funcionario.dataInicioAtividade;
      }
    },
    async listaAgendamentos(funcionarioId) {
      this.carregando = true;
      try {
        const endPoint = `agendamentos-ferias`;
        const agendamentosResponse = await api.get(endPoint);

        let agendamentos = [];

        if (!!agendamentosResponse) {
          agendamentos = agendamentosResponse.content;
        }

        if (!agendamentos || !agendamentos.length) {
          this.feriasAgendadas = [];
          return;
        }

        const agendamentosFuncionarioSelecionado = agendamentos.filter(agendamento => agendamento.periodoAquisitivo.funcionario.id == funcionarioId);
        this.agendamentos = agendamentosFuncionarioSelecionado;

        const feriasMapeadas = this.mapeiaFeriasAgendadas(this.agendamentos);
        // const feriasMapeadas = this.mapeiaFeriasAgendadas(agendamentosMock);
        const feriasComProtocolo = await this.incluiProtocolos(feriasMapeadas);
        this.feriasAgendadas = feriasComProtocolo;

        this.usuarioValido = true;
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);

        if (mensagem === 'Funcionário não localizado ou acesso negado') {
          this.$router.push({ name: 'UorNaoParticipante' });
          this.usuarioValido = false;
          return;
        }

        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      } finally {
        this.carregando = false;
      }
    },
    async obtemMesCompetencia(funcionarioId) {
      this.carregandoAprovador = true;
      try {
        const endPointCompetencias = `agendamentos-ferias/funcionarios/${funcionarioId}/competencias`;
        const competenciaResponse = await api.get(endPointCompetencias);

        if (!competenciaResponse) {
          throw new Error();
        }

        if (!!competenciaResponse && !competenciaResponse.id) {
          this.$root.$refs.toastr.e(
            'Não encontramos os dados do mês que ' +
              'compete ao agendamento. Por favor, avise ao DETIC sobre essa mensagem',
            'Atenção',
          );

          return;
        }

        if (!!competenciaResponse && !competenciaResponse.acessaAgendamento) {
          this.$router.push({ name: 'UorNaoParticipante' });
          this.usuarioValido = false;

          return;
        }

        this.competencia = competenciaResponse;
        this.agendaSabado = competenciaResponse.agendaSabado;
        this.agendaDomingoFeriado = competenciaResponse.agendaDomingoFeriado;
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        if (mensagem === 'Funcionário não localizado ou acesso negado') {
          this.$router.push({ name: 'UorNaoParticipante' });
          this.usuarioValido = false;
          return;
        }

        if (mensagem === 'Agendamento de Férias está fechado para lançamento') {
          this.escondeAprovador = true;
          return;
        }

        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      } finally {
        this.carregandoAprovador = false;
      }
    },
    async listaAprovadores(mesCompetencia, uorId) {
      this.carregandoAprovador = true;

      try {
        const endPointResponsaveis =
          `agendamentos-ferias/competencias/${mesCompetencia}/` +
          `unidades-organizacionais/${uorId}/responsaveis`;
        const responsaveisResponse = await api.get(endPointResponsaveis);

        if (!responsaveisResponse.length) {
          this.aprovadores = [];
          return;
        }

        this.mapeiaAprovadores(responsaveisResponse);
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      } finally {
        this.carregandoAprovador = false;
      }
    },
    async obtemProtocolo(agendamentoId) {
      try {
        const endPointAgendamento = `agendamentos-ferias/${agendamentoId}`;
        const agendamentoResponse = await api.get(endPointAgendamento);

        return agendamentoResponse && agendamentoResponse.protocolo;
      } catch (error) {
        const mensagem = ErrorHelper.trataMensagem(error);
        this.$root.$refs.toastr.e(mensagem, 'Atenção');
      }
    },

    // Métodos handle
    mapeiaFeriasAgendadas(agendamentos) {
      const feriasMapeadas = agendamentos.reduce((result, ferias) => {
        if (ferias !== {}) {
          result.push(
            new Ferias(
              ferias.id,
              ferias.periodoAquisitivo.id,
              ferias.dataIninico
                ? ferias.dataInicio.substr(0, 4)
                : ferias.periodoAquisitivo.competencia.ano,
              ferias.periodoAquisitivo.competencia.ano,
              ferias.dataInicio,
              ferias.periodoAquisitivo.possuiDiasPendentes,
              ferias.periodoAquisitivo.possuiFeriasPendentes,
              ferias.statusAprovacao,
              ferias.periodo.anoCompetencia,
              ferias.periodo.mesCompetencia
            ),
          );
        }

        return result;
      }, []);

      return feriasMapeadas;
    },
    mapeiaAprovadores(responsaveisResponse) {
      this.aprovadores = responsaveisResponse.map(
        aprovador =>
          new Aprovador(
            (aprovador.id = aprovador.funcionarioResponsavel.id),
            (aprovador.nome = aprovador.funcionarioResponsavel.nome),
            (aprovador.registro = aprovador.funcionarioResponsavel.registro),
            (aprovador.cargo = aprovador.funcionarioResponsavel.cargo),
          ),
      );
    },
    trataInicioParaModal(ferias, feriasAgendadas) {
      const formatoData = 'YYYY-MM-DD';
      const agendamento = this.agendamentos.find(agendamento => agendamento.id === ferias.id);
      const periodo = agendamento.periodo;

      return moment(`${periodo.anoCompetencia}-${periodo.mesCompetencia}-01`, formatoData)
        .add(2, 'months')
        .format(formatoData);
    },
    async incluiProtocolos(feriasMapeadas) {
      const feriasComProtocolo = feriasMapeadas.map(async ferias => {
        if (ferias.inicio) {
          const protocolo = await this.obtemProtocolo(ferias.id);
          if (protocolo) ferias.protocolo = protocolo.codigo;
        }

        return ferias;
      });

      const feriasResolvidas = await Promise.all(feriasComProtocolo);

      return feriasResolvidas;
    },

    // Outros métodos
    abreProtocolo({ protocolo, agendamentoId }) {
      this.protocolo = protocolo;
      this.agendamentoId = agendamentoId;
      setTimeout(() => {
        jQuery('#protocoloModal').modal('show');
      }, 600);
    },
    abreExplicacaoModal() {
      jQuery('#explicacaoModal').modal('show');
    },
    abreRegraDiasPendentes() {
      jQuery('#regraDiasPendentesModal').modal('show');
    },
    abreRegraFeriasPendentes() {
      jQuery('#regraFeriasPendentesModal').modal('show');
    },
    mostraEditar(ferias) {
      if (ferias) {
        const naoAgendado = ferias.situacao === 'PENDENTE';

        const naoTemDiasFeriasPendentes =
          !ferias.diasPendentes && !ferias.feriasPendentes;

        const temDireitoFerias = this.temDireitoFerias(ferias);

        return naoAgendado && naoTemDiasFeriasPendentes && temDireitoFerias;
      }

      return false;
    },
    temDireitoFerias(ferias) {
      if(ferias) {
        const [ano, mes, dia] = this.usuarioAtual.dataInicioAtividade.split('-');

        const dataDireitoFerias = new Date(+ano + 1, +mes - 1, +dia);
        const anoInicioDireito = dataDireitoFerias.getFullYear();
        const mesInicioDireito = dataDireitoFerias.getMonth();

        const dataFerias = new Date(ferias.anoAgendamento, (+ferias.mesAgendamento-1) + 2, 1);
        const anoFerias = dataFerias.getFullYear();
        const mesFerias = dataFerias.getMonth();

        if ((anoInicioDireito > anoFerias)
          || (anoInicioDireito == anoFerias && mesInicioDireito > mesFerias)) {
          return false;
        }

        return true;
      }

      return false;
    },
    mostraVisualizar(ferias) {
      if (ferias) {
        const agendado = ferias.situacao !== 'PENDENTE';
        const naoTemDiasFeriasPendentes =
          !ferias.diasPendentes && !ferias.feriasPendentes;

        return agendado && naoTemDiasFeriasPendentes;
      }

      return false;
    },
    mostraDiasFeriasPendentes(ferias) {
      if (ferias) {
        const temDiasPendentes = ferias.diasPendentes;
        const temFeriasPendentes = ferias.feriasPendentes;

        return temDiasPendentes || temFeriasPendentes;
      }

      return false;
    },
    alternaTooltipDiasFerias(ferias) {
      if (ferias) {
        return ferias.diasPendentes ? 'Dias pendentes' : 'Férias pendentes';
      }
    },
  },

  filters: {
    descricaoStatus(status) {
      let descricao = status;

      switch(status) {
        case 'EM_ANALISE': descricao = 'EM ANÁLISE'; break;
        case 'SEGUNDA_APROVACAO': descricao = 'SEGUNDA APROVAÇÃO'; break;
        case 'MARCADA': descricao = 'MARCADA/GOZADA'; break;
      }

      return descricao;
    }
  },

  created() {
    this.editaRegistro(this.funcionario);
  },

  mounted() {
    window.scrollTo(0, 0);
  },

  components: {
    Botao,
    SideModal,
    ProtocoloModal,
    RegraDiasPendentesModal,
    RegraFeriasPendentesModal,
    CardHeader,
    ExplicacaoModal,
    TableLoader,
  },
};
</script>

<style scoped>
@media screen and (max-width: 520px) {
  .hidden-xxs {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// agendamento.vue?7c41aa88